import CityPage from "../CityPage";

export default function ArlingtonHeights() {
  return <CityPage slug="arlington-heights" />;
}
